import { type QuizQuestionText } from '@efdigital/ll-addon-data';
import { uniqueId } from '@ember/helper';
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';

import type { QuizQuestionEditorComponentSignature } from '../../types/question-manager';
import RequiredCheckbox from './shared/required-checkbox.gts';

function not(value: boolean) {
  return !value;
}

export class TextQuestionEditorComponent extends Component<QuizQuestionEditorComponentSignature> {
  get questionData(): QuizQuestionText {
    return this.args.question.text!;
  }

  setMultiline = (value: boolean) => {
    this.questionData.multiline = value;
  };

  <template>
    {{#let (uniqueId) as |uniqueId|}}
      <div class="card-body">
        <RequiredCheckbox @question={{@question}} />

        <div class="form-label">Input Type</div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="exampleRadios"
            id="{{uniqueId}}-singleline"
            autocomplete="off"
            checked={{not this.questionData.multiline}}
            {{on "change" (fn this.setMultiline false)}}
          />
          <label class="form-check-label" for="{{uniqueId}}-singleline">
            Single line
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="exampleRadios"
            id="{{uniqueId}}-multiline"
            value="option2"
            checked={{this.questionData.multiline}}
            {{on "change" (fn this.setMultiline true)}}
          />
          <label class="form-check-label" for="{{uniqueId}}-multiline">
            Multiple lines
          </label>
        </div>
      </div>
    {{/let}}
  </template>
}
